// src/theme-provider/foundations/radius.ts
var radius = {
  none: "0",
  sm: ".25rem",
  md: ".5rem",
  lg: "1rem",
  xl: "1.5rem",
  "2xl": "2.5rem",
  "3xl": "6.25rem"
};
var radius_default = radius;

export {
  radius_default
};
